import React from 'react';
import { RouteComponentProps } from '@reach/router';
import Page from '../components/Page';

export default (props: RouteComponentProps) => {
  return <Page>Terms and Conditions that our legal advisors will fight you legally</Page>;
};
